import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../../Button/PlainButtonOrLink';
import MatureToggle from '../../../MatureToggle';
import { BiEventType } from '../../../biLogger/constants';
import { ThemeOptions } from '../../../publicSession';
import ThemeToggle from '../../_partials/ThemeToggle';
import s from './UserMenu.scss';
export function getMatureToggle(matureContent, toggleMature, t) {
    return {
        label: (React.createElement("div", { className: classnames(s['mature-label'], s['two-side-label']) },
            React.createElement("span", { id: "user-menu-mature-label", onClick: function () { return toggleMature(matureContent); } }, t('siteHeaderMobile.userMenu.matureContent')),
            React.createElement(MatureToggle, { className: classnames(s['mature-toggle'], matureContent && s['checked']), forcedLightTheme: true, checked: matureContent, onChange: toggleMature, "aria-labelledby": "user-menu-mature-label" }))),
        biData: {
            evid: BiEventType.TOP_NAV_MENU_CLICK,
            menu_item: 'toggle_mature',
            menu_name: 'profile',
            toggle_value: !matureContent ? 'mature_on' : 'mature_off',
        },
    };
}
export function getThemeToggle(theme, toggleTheme, t) {
    return {
        label: (React.createElement("div", { className: s['two-side-label'] },
            React.createElement("span", null, t('siteHeaderMobile.userMenu.mode')),
            React.createElement(PlainButtonOrLink, { "aria-label": t('siteHeader.userMenu.themeDark'), "aria-pressed": theme === ThemeOptions.DARK, tabIndex: 0, onClick: function () { return toggleTheme(); } },
                React.createElement(ThemeToggle, { className: s['theme-toggle'] })))),
        biData: {
            evid: BiEventType.TOP_NAV_MENU_CLICK,
            menu_item: 'toggle_theme',
            menu_name: 'profile',
            toggle_value: theme === 'light' ? 'dark' : 'light',
        },
    };
}
//# sourceMappingURL=menuItemHelpers.js.map